import React from 'react';
import { Section } from '@/components/shared/section/Section';

export const NotFound: React.FC = () => {
  return (
    <Section title="404 Not Found">
      <div className="flex flex-col items-center gap-1 p-10">
        <span className="text-lg font-bold">404 Not Found</span>
        <p>Maaf fitur ini sedang dalam tahap pengembangan.</p>
      </div>
    </Section>
  );
};
